import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { ApiPatchOperation, UpdateBlockInLibraryPayload } from '@root/@types/types';
import axios from 'axios';

export const updateBlock = async (
  id: string,
  data: UpdateBlockInLibraryPayload | { operation: ApiPatchOperation },
): Promise<string> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'patch',
    url: `blocks/${id}`,
    data,
  });

  const response = await axios(networkPayload);
  return response.data;
};
